const CalendarIcon = () => (
  <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.7002 2.46224H14.8627V1.62468C14.8627 1.16401 14.4858 0.787109 14.0251 0.787109C13.5644 0.787109 13.1875 1.16401 13.1875 1.62468V2.46224H4.81186V1.62468C4.81186 1.16401 4.43495 0.787109 3.97429 0.787109C3.51363 0.787109 3.13672 1.16401 3.13672 1.62468V2.46224H2.29916C1.37783 2.46224 0.624023 3.21605 0.624023 4.13738V17.5384C0.624023 18.4598 1.37783 19.2136 2.29916 19.2136H15.7002C16.6215 19.2136 17.3754 18.4598 17.3754 17.5384V4.13738C17.3754 3.21605 16.6215 2.46224 15.7002 2.46224ZM14.8627 17.5384H3.13672C2.67606 17.5384 2.29916 17.1615 2.29916 16.7009V6.65007H15.7002V16.7009C15.7002 17.1615 15.3233 17.5384 14.8627 17.5384Z"
      fill="currentColor"
    />
  </svg>
);
export default CalendarIcon;
